var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dlibr-layout"},[_c('DlibrNavbar',{staticClass:"mb-5"}),_c('div',{class:_vm.routeIsArborescenceGraph ? 'container-fluid' : 'container'},[_c('SiteContent')],1),_c('DlibrFooter',{staticClass:"site-footer"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }